export default __webpack_public_path__ + "images/524faa21a238329b65210de77f070cde.png";